import {Lightning} from '@lightningjs/sdk';

export default class WebpTexture extends Lightning.textures.ImageTexture {
    
    isWeb:any;
    isWPE:any;
    isSpark:any;
    isNode:any;
    isPS4:any;
    isZiggo:any;
    
    _hasAlpha = false

    constructor(stage) {
        super(stage);
        
        this.stage = stage;
        this.isWeb = (typeof window !== "undefined") && (typeof sparkscene === "undefined");
        this.isWPE = this.isWeb && (navigator.userAgent.indexOf("WPE") !== -1);
        this.isSpark = (typeof sparkscene !== "undefined");
        this.isNode = (typeof window === "undefined") || this.isSpark;
        this.isPS4 = this.isWeb && (navigator.userAgent.indexOf("PlayStation 4") !== -1);
        this.isZiggo = this.isWeb && (navigator.userAgent.indexOf("EOSSTB") !== -1 || navigator.userAgent.indexOf("HZNSTB") !== -1);
        
        this._hasAlpha = false
    }
    
    // 1. Explicitly trap the template's hasAlpha property assignment
    override set hasAlpha(v) {
        this._hasAlpha = v;
        
        // This line forces the underlying ImageTexture logic to respect the alpha channel flag
        if (this._source) {
            this._source.hasAlpha = v;
        }
        
        // Tell Lightning to re-evaluate the texture flags
        this._changed(); 
    }

    override get hasAlpha() {
        return this._hasAlpha;
    }
    
    override _getSourceLoader() {
        
        let src = this._src;
        let hasAlpha = this._hasAlpha;
        //console.log('_getSourceLoader', src, hasAlpha)
        if (this.stage.getOption('srcBasePath')) {
            var fc = src.charCodeAt(0);
            if ((src.indexOf("//") === -1) && ((fc >= 65 && fc <= 90) || (fc >= 97 && fc <= 122) || fc == 46)) {
                // Alphabetical or dot: prepend base path.
                src = this.stage.getOption('srcBasePath') + src;
            }
        }

        return (cb) => {
            return this.loadSrcTexture({src: src, hasAlpha: hasAlpha}, cb);
        }
    }

    loadSrcTexture({src: src, hasAlpha: hasAlpha}, cb) {

        let isWebP = (src.toLowerCase().indexOf(".webp") >= 0) || src.substr(0, 21) == 'data:image/webp;base64';
        
        if(!isWebP) {
            return this.stage.platform.loadSrcTexture({src: src, hasAlpha: hasAlpha}, cb);
        } else {
            // We need to scope these to protect them from modifications while loading (which may be async).
            let image = new Image();

            // On the PS4 platform setting the `crossOrigin` attribute on
            // images can cause CORS failures.
            if (!(src.substr(0, 5) == "data:") && !this.isPS4) {
                // Base64.
                image.crossOrigin = "Anonymous";
            }
            image.onerror = (err) => {
                // Ignore error message when cancelled.
                if (image.src) {
                    return cb("Image load error");
                }
            };
            image.onload = () => {
                // const canvas = document.createElement('canvas')
                // canvas.width = image.naturalWidth;
                // canvas.height = image.naturalHeight;
                
                // const ctx = canvas.getContext('2d',{alpha: this._hasAlpha});
                // ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                // // Draw the WebP image directly onto the canvas to capture clean alpha channel data
                // ctx.drawImage(image, 0, 0);
                // console.log(canvas, ctx)
                const gl = this.stage.gl || (this.stage.getCanvas && stage.getCanvas().getContext("webgl"));
                const texture = gl.createTexture();
                if (gl) {

                    
                    gl.bindTexture(gl.TEXTURE_2D, texture);

                    // Upload the decoded WebP pixel data to the GPU
                    gl.texImage2D(
                        gl.TEXTURE_2D, 
                        0,                // Mipmap level
                        gl.RGBA,          // Internal format (use gl.RGBA if your WebP has alpha transparency)
                        gl.RGBA,          // Source format
                        gl.UNSIGNED_BYTE, // Data type
                        image             // The loaded WebP DOM element
                    );

                    // Set texture scaling parameters
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    
                    // Handle edge wrapping (Clamp to edge is safest for custom image sizes)
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    // Direct the GPU unpack state to avoid flattening image color vectors 
                    // This mimics how standard 2D canvas structures unpack transparency models.
                    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
                }
                cb(null, {
                    source: texture,
                    renderInfo: { src: this._src, compressed: false },
                    hasAlpha: this._hasAlpha
                });
            };
            image.src = src;

            let cancelCb = function () {
                image.onerror = null;
                image.onload = null;
                image.removeAttribute('src');
            }
            
            return cancelCb
        }   
    }
}